import styled from "styled-components";

export const UserCard = styled.div `
    text-align: center;
    font-size: 1.5rem;
    text-transform: uppercase;
    width: 33%;
`

export const MainContainer = styled.div `
    display: flex;
`